import React, { Fragment, useContext, useEffect } from 'react';
import SongInfoArt from "../../orgnanisms/audio_player/molecules/SongInfoArt";
import WaveForm from "../../orgnanisms/audio_player/molecules/WaveForm";
import useBrandIcon from "../../../hooks/useBrandIcon";
import { Contribution } from "../../../utils/types";
import { GlobalContext } from "../../../context/GlobalContext";
import { formatNumber } from "../../../helpers/number";
import useWindowSize from "../../../hooks/useWindowSize";
import useContainerSize from "../../../hooks/useContainerSize";
import Button from "../Button";

interface Props {
    container_id: string;
    contribution: Contribution;
    showWaveFormDefault?: boolean;
}

const ContributionItem = ({ container_id, contribution, showWaveFormDefault = false }: Props) => {
    const { like, chat } = useBrandIcon();
    const waveFormRef = React.useRef(null);
    const { waveformRef, setWaveformRef } = useContext(GlobalContext);
    const { width } = useContainerSize(waveFormRef);
    const { isMobile } = useWindowSize();

    useEffect(() => {
        if (waveFormRef && setWaveformRef) {
            setWaveformRef(waveFormRef);
        }
    }, [setWaveformRef]);

    return (
        <Fragment>
            <div
                className={`${isMobile ? 'bg-neutral-950' : 'contribution_list_item'} 
                flex flex-col lg:flex-row justify-between items-start lg:items-center 
                w-full mt-6 py-4 sm:py-1 px-6 gap-4 overflow-hidden`}
            >
                {/* Song Info */}
                <SongInfoArt
                    title={contribution.song_title}
                    author={contribution.username}
                    art_url={contribution.user_avatar}
                    small
                />

                {/* Waveform + Social Section */}
                <div className="flex-1 w-full min-w-0 flex flex-col lg:flex-row items-center gap-4">
                    {/* Waveform - takes up available space */}
                    <div className="flex-1 min-w-[150px]">
                        <WaveForm
                            url={contribution.file_url}
                            container_id={container_id}
                            play
                            width={isMobile ? `${width! - 100}px` : '100%'}
                            height={30}
                            surferRef={waveformRef}
                            showTime={false}
                            social={null} // social moved outside for full control
                        />
                    </div>

                    {/* Social & Follow Buttons - fixed width */}
                    <div className="flex items-center gap-3 flex-shrink-0">
                        <div className="flex items-center gap-1 text-xs">
                            <img src={like} alt="like" className="w-[10px]" />
                            <span>{formatNumber(contribution.likes)}</span>
                        </div>

                        <div className="flex items-center gap-1 text-xs">
                            <img src={chat} alt="comment" className="w-[20px]" />
                            <span>{formatNumber(contribution.comments)}</span>
                        </div>

                        <Button
                            title={'Follow'}
                            onClick={() => null}
                            variant={'border'}
                            className={'button_rounded border_plain_primary !mb-0'}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ContributionItem;
